import { THEME_CONFIG } from "./env";

export const Colors = {
  Primary: THEME_CONFIG.color.primary || "#19B1D9",
  primary: THEME_CONFIG.color.primary || "#19B1D9",
  Secondary: "#127E9A",
  secondary: "#127E9A",
  Tertiary: "#7F0000",

  //------------- Button -------------
  ButtonHover: "#17A1C5",
  ButtonPress: "#127E9A",
  ButtonDisable: "#6A6A6A",
  ButtonHoverSecondary: "#C0C0C0",
  ButtonPressSecondary: "#8D8D8D",

  //------------- Text -------------
  TextDefault: "#FFFFFF",
  TextSecondary: "#000000",
  TextSilver: "#C0C0C0",
  TextGray: "#8D8D8D",
  TextDisable: "#6A6A6A",
  TextCharcoal: "#505050",
  TextGraphite: "#303030",

  text0: "#000000",
  text1: "#ffffff",
  text2: "#bdbdbd",
  text3: "#7b808d",
  text4: "#6a6a6a",

  //------------- Backgrounds -------------
  Background1: "#141414",
  Background2: "#1B1B1B",
  Background3: "#222222",
  Background4: "#343434",
  Background5: "#3F3F3F",
  Background6: "#BBBBBB",
  Background7: "#FFFFFF",
  Background8: "#000000",
  Background9: "#E60000",

  background1: "#141414",
  background2: "#1B1B1B",
  background3: "#222222",
  background4: "#343434",
  background5: "#3F3F3F",
  background6: "#BBBBBB",
  background7: "#FFFFFF",
  background8: "#000000",
  background9: "#E60000",

  BackgroundPrimary:
    "linear-gradient(180deg, #1C7F99 0%, #22CEFB 50%, #1C7F99 100%)",
  BackgroundBackdrop:
    "linear-gradient(180deg, rgba(20, 20, 20, 0.90) 0%, rgba(20, 20, 20, 0.90) 100%)",

  //------------- Border -------------
  Border1: "rgba(255, 255, 255, 0.20)",
  Border2: "rgba(255, 255, 255, 0.40)",
  Border3: "rgba(255, 255, 255, 0.60)",
  Border4: "rgba(255, 255, 255, 0.80)",

  // ------------- Border Lib UI -------------
  border1: "rgba(255, 255, 255, 0.20)",
  border2: "rgba(255, 255, 255, 0.40)",
  border3: "rgba(255, 255, 255, 0.60)",
  border4: "rgba(255, 255, 255, 0.80)",

  //------------- Functional Color -------------
  NotificationSuccess: "#3CB84E",
  NotificationWarning: "#FAA356",
  NotificationError: "#EE4E42",
};

export const Radius = {
  button: 4,
  small: 8,
  medium: 16,
  large: 24,
};

export const Shadows = {
  dp1: "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)",
  dp2: "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)",
  dp3: "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)",
  dp4: "0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px 0px rgba(0, 0, 0, 0.30)",
  dp5: "0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px 0px rgba(0, 0, 0, 0.30)",
};

export const Spacing = {
  space2: 2,
  space4: 4,
  space8: 8,
  space12: 12,
  space16: 16,
  space20: 20,
  space24: 24,
  space28: 28,
  space32: 32,
  space36: 36,
  space40: 40,
  space48: 48,
  space100: 100,
};

export const FontWeight = {
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
};

export const ZIndex = {
  normal: 1,
  appBar: 110,
  dialog: 1900,
};
